export default {"src":"https://s.sylndr.com/c-f6814a1/_next/static/media/websiteLogoArWhite.c02f7a5c.svg","height":37,"width":129,"blurWidth":0,"blurHeight":0};